import { render, staticRenderFns } from "./BaseRadioButton.vue?vue&type=template&id=395177f5&scoped=true"
import script from "./BaseRadioButton.vue?vue&type=script&lang=ts"
export * from "./BaseRadioButton.vue?vue&type=script&lang=ts"
import style0 from "./BaseRadioButton.vue?vue&type=style&index=0&id=395177f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395177f5",
  null
  
)

export default component.exports